import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Discount, DiscountRepository, Loading } from "../domain";
import { ServiceLocater, Services } from "../service-locater";
import { AppThunk } from "./store";

type DiscountsState = {
  loading: Loading;
  discounts: Discount[];
};

const initialState: DiscountsState = {
  loading: "idle",
  discounts: [],
};

const discountSlice = createSlice({
  name: "discounts",
  initialState,
  reducers: {
    discountsLoading(state) {
      state.loading = "pending";
    },
    discountsFailed(state) {
      state.loading = "failed";
    },
    discountsLoaded(state, { payload }: PayloadAction<Discount[]>) {
      state.discounts = payload;
      state.loading = "succeeded";
    },
  },
});

export default discountSlice.reducer;

const {
  discountsLoading,
  discountsFailed,
  discountsLoaded,
} = discountSlice.actions;

export const loadDiscounts = (): AppThunk => async (dispatch) => {
  dispatch(discountsLoading());
  const res = await ServiceLocater.get<DiscountRepository>(
    Services.DiscountRepository
  ).list();
  res.fold(
    (_) => {
      dispatch(discountsFailed());
    },
    (r) => {
      dispatch(discountsLoaded(r));
    }
  );
};
